export enum GameStep {
    LOBBY,
    GUESSING,
    RESULT,
    RECAP,
}